import DCSDApi from './_dvcApi';
import httpClient from '@/apis/base/httpclient';

class DCSDFileAPI extends DCSDApi {
  constructor() {
    super();
  }
  controllerName = 'DCSDFiles';

  /**
   * Hàm lưu dữ liệu
   * @param {} param
   * @returns
   */
  saveVoucherDcsd(param) {
    let request = {
      url: this.getAPIUrl() + '/saveDcsd',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /**
   * Hàm lấy dữ liệu sửa
   * @param {} id
   * @returns
   */
  async getDataVoucherDcsd(id) {
    let request = {
      url: this.getAPIUrl() + '/getEditDcsd',
      data: {id},
    };

    return await httpClient.getAsync(request);
  }
  /**
   * Hàm lấy dữ liệu thêm mới
   * @param {} id
   * @returns
   */
  async getNewVoucherDcsd() {
    let request = {
      url: this.getAPIUrl() + '/getNew',
      data: {},
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy số hồ sơ tự tăng
   * @returns
   */
  async getFileCodeDcsd(fileCode, dvcToken, createdDate) {
    let request = {
      url: this.getAPIUrl() + '/getFileCodeDcsd',
      data: {fileCode, dvcToken, createdDate},
    };
    return await httpClient.getAsync(request);
  }

  /**
   * Hàm từ chối duyệt hồ sơ
   */
  RejectDocument(param) {
    let request = {
      url: this.getAPIUrl() + '/RejectDcsd',
      data: param,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Hàm gửi duyệt hồ sơ
   * DMNGOC 20/10/2022
   */
  async SendApprovalDcsd(param) {
    let request = {
      url: this.getAPIUrl() + '/SendApprovalDcsd',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu
   * @param {} id
   * @returns
   */
  async getDataDetailDcsd(param) {
    let request = {
      url: this.getAPIUrl() + '/getDataDetailDcsd',
      data: param,
    };

    return await httpClient.postAsync(request);
  }

  /* Hàm duyệt bằng usbTokens
   * @param {*} param
   * @returns
   * dtnga3 (21.12.2022)
   */
  approveByUsbToken(param) {
    let request = {
      url: this.getAPIUrl() + '/approveDcsdByUsbToken',
      data: param,
    };

    return httpClient.postAsync(request);
  }
  /* Hàm duyệt lại
   * @param {*} param
   * @returns
   * nthien4 22/09/2023
   */
  approveAgain(param) {
    let request = {
      url: this.getAPIUrl() + '/approveDcsdAgain',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /* Hàm duyệt bằng Esign
   * @param {*} param
   * @returns
   * dtnga3 (26.04.2022)
   */
  approveByEsign(param) {
    let request = {
      url: this.getAPIUrl() + '/approveDcsd',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy dữ liệu tính chất nguồn mẫu N04a
   * @param {} id
   * @returns
   */
  async getN04aBudgetSourceProperty(param) {
    let request = {
      url: this.getAPIUrl() + '/n04aBudgetSourceProperty',
      data: param,
    };

    return await httpClient.getAsync(request);
  }

  /**
   * Hàm lấy mã hồ sơ mới nhất khi duyệt trùng mã
   * @param {*} param
   * @returns
   */
  updateNewDCSDFileCode(param) {
    let request = {
      url: this.getAPIUrl() + '/updateNewDCSDFileCode',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * Hàm lấy link xuất pdf
   * @param {*} param 
   * @returns 
   */
  async linkExportPDF(param) {
    let request = {
      url: this.getAPIUrl() + '/linkExportPDF',
      data: param,
    };

    return httpClient.getAsync(request);
  }
}

export default new DCSDFileAPI();
